import { NavLink } from 'react-router';
import { useI18n } from '../../i18n';
import { useSyndicate } from '../../session';

/** Sub-navigation of the board's governance pages. */
export function GovernanceNav() {
  const { t } = useI18n();
  const base = `${useSyndicate().base}/governance`;
  const g = t.governance.sections;
  return (
    <nav className="subnav" aria-label={t.governance.title}>
      <NavLink to={base} end>
        {g.meetings}
      </NavLink>
      <NavLink to={`${base}/written`}>{g.written}</NavLink>
      <NavLink to={`${base}/registers`}>{g.registers}</NavLink>
    </nav>
  );
}
